import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { AuthHeaderComponent } from '../../components/auth-header/auth-header.component';
import { LanguageSwitchComponent } from '@shared/widgets/language-switch/language-switch.component';
import { LoginFormComponent } from '../components/login-form/login-form.component';
import { takeUntilDestroyedSafe } from '@core/helpers/take-until-destroyed-safe';

@Component({
    selector: 'app-login-view',
    templateUrl: './login-view.component.html',
    styleUrls: ['./login-view.component.scss'],
    imports: [SvgIconComponent, AuthHeaderComponent, LanguageSwitchComponent, LoginFormComponent, TranslateModule]
})
export class LoginViewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  private auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);

  checking = true;

  ngOnInit(): void {
    this.auth
      .getUser()
      .pipe(takeUntilDestroyedSafe(this.destroyRef))
      .subscribe((user) => {
        if (user) {
          this.router.navigate(['/dashboard']);
        }
      });

    if (this.auth.isLoggedIn) {
      this.router.navigate(['/dashboard']);
    } else {
      setTimeout(() => {
        this.checking = false;
      }, 1000);
    }
  }

  items: {
    id: string;
    language?: string;
    action: string;
  }[] = [
    {
      id: 'pl',
      language: this.translate.instant('switch-language.polish'),
      action: 'switch-language',
    },
    {
      id: 'en',
      language: this.translate.instant('switch-language.english'),
      action: 'switch-language',
    },
  ];
}
